import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

const Lubricant: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox='0 0 24 24'>
      <g fill={props?.fill ?? '#1E1E1E'} clipPath='url(#a)'>
        <path d='M21.555 3.517 18.905.874l-1.779 1.772-2.65-2.643H9.185L.364 8.816a1.252 1.252 0 0 0 0 1.766l7.06 7.047c.486.486 1.28.486 1.766 0L20.66 6.166l-.884-.876 1.78-1.773ZM8.301 7.933 6.528 6.166l3.54-3.526h3.538L8.301 7.933ZM20.397 13.187s-3.603 5.216-3.603 7.207a3.603 3.603 0 1 0 7.206 0c0-1.99-3.603-7.207-3.603-7.207ZM21.6 8.394s-1.197 1.734-1.197 2.4a1.2 1.2 0 0 0 1.197 1.203 1.2 1.2 0 0 0 1.197-1.203c0-.666-1.197-2.4-1.197-2.4Z' />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </SvgIcon>
  )
}

export default Lubricant
